/**
 * Created by xupengwei on 2018/6/26.
 * Modified by heyushuang on 2019/9/26.
 */

let zhHansI18n = {
  'timeout': '请求超时',
  'btnNext': '下一步',
  'commonTitle': '安装',
  'modelTitle': '车库门二代马达匹配清单',
  'commonNodata': '没有数据',
  'commonLoading': '加载中',
  'openGLoading': '正在开启车库门...',
  'commonFail': '失败',
  'commonTryAgain': '重试',
  'commonNo': '否',
  'commonYes': '是',
  'commonOk': '好的',
  'commonSubmit': '提交',
  'commonCancel': '取消',
  'modelDescItem1': '查看电机型号',
  'modelDescItem2': '请在电机上找到厂商及型号信息，并进行如下选择。',
  'modelDescItem3': '如果您可以在列表中看到您的设备，则表明您的设备兼容。',
  'modelDescTips': [
      '如果没有在列表中找到您的电机型号，请参考',
      '典型电机图示',
      '进行安装'
    ],
  'factoryPlaceholder': '选择厂商',
  'modelPlaceholder': '选择型号',
  'appAlcidaes': '海雀',
  'appDanales': '大拿',
};
export default zhHansI18n;




// WEBPACK FOOTER //
// ./src/i18n/messages/zh-Hans.i18n.js